import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { logger } from '../logger';
import { BaseMetric, MetricState } from './base-metric';
export var BasePageLoadMetric = /*#__PURE__*/function (_BaseMetric) {
  function BasePageLoadMetric(args) {
    var _this;
    _classCallCheck(this, BasePageLoadMetric);
    _this = _callSuper(this, BasePageLoadMetric, [args]);
    _defineProperty(_this, "isInitial", true);
    _defineProperty(_this, "explicitTimings", null);
    _this.config = args;
    return _this;
  }
  _inherits(BasePageLoadMetric, _BaseMetric);
  return _createClass(BasePageLoadMetric, [{
    key: "start",
    value: function start() {
      _objectDestructuringEmpty(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
      // please use startPageLoad
      return;
    }
  }, {
    key: "startPageLoad",
    value: function startPageLoad() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isInitial: false
      };
      // todo this should update meta page load metric
      this.isInitial = params.isInitial;
      if (params.isInitial) {
        _superPropGet(BasePageLoadMetric, "start", this, 3)([{
          startTime: 0
        }]);
      } else {
        _superPropGet(BasePageLoadMetric, "start", this, 3)([params]);
      }
      logger.logCond(!!this.config.debug, this.key, this.startTime);
    }
  }, {
    key: "stopPageLoad",
    value: function stopPageLoad(pageLoadMetaMetricData) {
      var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stopTime: window.performance.now()
      };
      if (pageLoadMetaMetricData.state !== MetricState.STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
        logger.log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
        return false;
      }
      if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
        logger.log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
        return false;
      }
      this.merge(pageLoadMetaMetricData);
      this.stopTime = stopArguments.stopTime;
      this.state = MetricState.FINISHED;
      this.handleStop(stopArguments);
      return true;
    }
  }, {
    key: "handleStop",
    value: function handleStop(stopArguments) {
      var until = this.config.until;
      var fmpWasMarked = (BasePageLoadMetric.FMP in this.marks);
      if (!fmpWasMarked && until) {
        // Extract the maximum FMP value from the until metrics
        var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([until]);
        var untilFmpMarks = untilArr.map(function (metric) {
          return metric.getFmp();
        });
        if (untilFmpMarks.every(Number.isFinite)) {
          this.markFMP(Math.max.apply(Math, _toConsumableArray(untilFmpMarks)));
        }
      }
      _superPropGet(BasePageLoadMetric, "handleStop", this, 3)([stopArguments]);
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      if (_mark === BasePageLoadMetric.FMP) {
        return;
      }
      _superPropGet(BasePageLoadMetric, "mark", this, 3)([_mark, timestamp]);
    }
  }, {
    key: "merge",
    value: function merge(mergeData) {
      _superPropGet(BasePageLoadMetric, "merge", this, 3)([mergeData]);
      this.isInitial = mergeData.isInitial;
      this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? _objectSpread(_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
    }
  }, {
    key: "markFMP",
    value: function markFMP(timestamp) {
      _superPropGet(BasePageLoadMetric, "mark", this, 3)([BasePageLoadMetric.FMP, timestamp]);
    }
  }, {
    key: "getPageLoadData",
    value: function getPageLoadData() {
      return {
        isInitial: this.isInitial,
        explicitTimings: this.explicitTimings
      };
    }
  }, {
    key: "getData",
    value: function getData() {
      return _objectSpread(_objectSpread({}, _superPropGet(BasePageLoadMetric, "getData", this, 3)([])), this.getPageLoadData());
    }
  }, {
    key: "getDataToMerge",
    value: function getDataToMerge() {
      return _objectSpread(_objectSpread({}, _superPropGet(BasePageLoadMetric, "getDataToMerge", this, 3)([])), this.getPageLoadData());
    }
  }, {
    key: "clear",
    value: function clear() {
      this.explicitTimings = null;
      _superPropGet(BasePageLoadMetric, "clear", this, 3)([]);
    }
  }]);
}(BaseMetric);
_defineProperty(BasePageLoadMetric, "FMP", 'fmp');